var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-action/Share/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.9206349,14.7089947 C16.3817057,14.7089947 17.5661376,15.8934266 17.5661376,17.3544974 C17.5661376,18.8155681 16.3817057,20 14.9206349,20 C13.4595642,20 12.2751323,18.8155681 12.2751323,17.3544974 C12.2751323,16.9725374 12.3560798,16.6094836 12.5017556,16.2815553 L4.54183188,11.6858912 C4.06120313,12.1799076 3.38918895,12.4867725 2.64550265,12.4867725 C1.18443188,12.4867725 0,11.3023406 0,9.84126984 C0,8.38019907 1.18443188,7.1957672 2.64550265,7.1957672 C3.41477148,7.1957672 4.10735239,7.52410725 4.59074793,8.04828992 L12.4249219,3.52522749 C12.3279083,3.25000463 12.2751323,2.95391689 12.2751323,2.64550265 C12.2751323,1.18443188 13.4595642,0 14.9206349,0 C16.3817057,0 17.5661376,1.18443188 17.5661376,2.64550265 C17.5661376,4.10657341 16.3817057,5.29100529 14.9206349,5.29100529 C14.1223581,5.29100529 13.4066619,4.93743597 12.9216048,4.3783559 L5.11343389,8.88640547 C5.22811224,9.18259898 5.29100529,9.50458968 5.29100529,9.84126984 C5.29100529,10.2026693 5.2185379,10.5471431 5.08734149,10.8609529 L13.0663385,15.467629 C13.5437322,14.9984253 14.1983835,14.7089947 14.9206349,14.7089947 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-action/Share/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDarkblue);
export default __webpack_public_path__ + "static/media/share_darkblue.735df9945746bcd69528bdda89a11575.svg";
export { ForwardRef as ReactComponent };